import axios from 'axios'
import { jwtDecode } from 'jwt-decode'

import { decodeUserEmail, decodeUserId, decodeUserName } from '@/utils/userUtils'

// Perform login a request and return structured auth data.
export async function login(credentials) {
    const response = await axios.post('/users/token', credentials)
    const token = response?.data?.token

    const decoded = token ? jwtDecode(token) || {} : {}
    const userId = token ? decodeUserId(token) : null
    const userEmail = token ? decodeUserEmail(token) : null
    const userName = decodeUserName(JSON.stringify(decoded))

    return { token, userId, userEmail, userName, response }
}

// Refresh the JWT token and return the new token.
export async function refreshToken(currentToken) {
    const response = await axios.post('/users/token-refresh', { token: currentToken })
    const newToken = response?.data?.token
    return { token: newToken, response }
}
